var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("adminUser.adminUsers") }],
            select: true,
          },
        },
        [
          _c("a-input-search", {
            staticClass: "search-input",
            attrs: { placeholder: _vm.$t("message.search") },
            on: { search: _vm.onSearch },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
          _vm._v(" "),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.user-form",
                  modifiers: { "user-form": true },
                },
              ],
              staticClass: "actionButtonBreadcrumb",
              on: { click: _vm.showModalWithoutEdit },
            },
            [
              _c("md-icon", [_vm._v("add")]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("adminUser.newAdminUser")) +
                  "\n        "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.user-form",
                  modifiers: { "user-form": true },
                },
              ],
              staticClass: "actionButtonBreadcrumb ml-1",
              on: { click: _vm.startPaymentWorker },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "12px", "margin-right": "5px" },
                },
                [_vm._v(" system_update_alt ")]
              ),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("adminUser.startPaymentWorker")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.user-form",
                  modifiers: { "user-form": true },
                },
              ],
              staticClass: "actionButtonBreadcrumb ml-1",
              on: { click: _vm.startInvoiceWorker },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "12px", "margin-right": "5px" },
                },
                [_vm._v(" system_update_alt ")]
              ),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("adminUser.startInvoiceWorker")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "table-scroll-wrapper" },
                  [
                    _c("a-table", {
                      key: "vtable-" + _vm.renderCount,
                      staticClass: "custom-table2",
                      attrs: {
                        columns: _vm.cols(),
                        dataSource: _vm.getFilteredRows(),
                        loading: _vm.isBusy,
                        locale: { emptyText: _vm.$t("message.noNewAdminUser") },
                        pagination: false,
                        scroll: { x: "max-content" },
                        rowKey: "_id",
                      },
                      on: { change: _vm.tableChange },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "statusSlot",
                            fn: function (data, item) {
                              return _c(
                                "div",
                                { key: "statusSlot" + _vm.$i18n.locale },
                                [
                                  _c(
                                    "md-switch",
                                    {
                                      staticClass: "md-primary",
                                      staticStyle: { margin: "0" },
                                      on: {
                                        change: function (e) {
                                          return _vm.toggleChange(item)(e)
                                        },
                                      },
                                      model: {
                                        value: item.enable,
                                        callback: function ($$v) {
                                          _vm.$set(item, "enable", $$v)
                                        },
                                        expression: "item.enable",
                                      },
                                    },
                                    [
                                      item.enable
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.active"))
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.passive"))
                                            ),
                                          ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "actionsSlot",
                            fn: function (data, item) {
                              return _c(
                                "div",
                                { key: "actionsSlot-" + _vm.$i18n.locale },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex w-100 justify-content-center",
                                    },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "actionButton d-flex align-items-center",
                                          on: {
                                            click: function ($event) {
                                              return _vm.edit(item._id)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-right": "16px",
                                                display: "block",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.edit"))
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("ActionEdit"),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.loggedUser._id !== item._id
                                        ? _c(
                                            "a-button",
                                            {
                                              staticClass:
                                                "actionButton d-flex align-items-center",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.remove(item._id)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "16px",
                                                    display: "block",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.deleteField"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("ActionDelete"),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _c("Pagination", {
                      attrs: {
                        "page-change": _vm.pageChange,
                        "page-sizes": _vm.pageSizes,
                        total: _vm.adminUsers.total,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "user-form",
                title: _vm.editMode
                  ? _vm.$t("adminUser.updateAdminUserForm")
                  : _vm.$t("adminUser.newAdminUserForm"),
                "show-footer": false,
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c(
                "b-form",
                {
                  staticClass: "d-flex flex-column justify-content-center",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleSave.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "md-field",
                            {
                              class: {
                                "md-invalid":
                                  _vm.errors.first(_vm.$t("message.name")) !=
                                  null,
                              },
                            },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.name"))),
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: { name: _vm.$t("message.name") },
                                model: {
                                  value: _vm.adminUser.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.adminUser, "name", $$v)
                                  },
                                  expression: "adminUser.name",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-error" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.first(_vm.$t("message.name"))
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "md-field",
                            {
                              class: {
                                "md-invalid":
                                  _vm.errors.first(_vm.$t("message.email")) !=
                                  null,
                              },
                            },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.email"))),
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|email",
                                    expression: "'required|email'",
                                  },
                                ],
                                attrs: {
                                  name: _vm.$t("message.email"),
                                  autocomplete: "off",
                                  trim: "",
                                },
                                model: {
                                  value: _vm.adminUser.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.adminUser, "email", $$v)
                                  },
                                  expression: "adminUser.email",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-error" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.first(_vm.$t("message.email"))
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "md-field",
                            {
                              class: {
                                "md-invalid":
                                  _vm.errors.first(
                                    _vm.$t("message.password")
                                  ) != null,
                              },
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.passwordAtLeast", {
                                      num: "6",
                                    })
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: _vm.editMode
                                      ? "min:6"
                                      : "required|min:6",
                                    expression:
                                      "editMode ? 'min:6' : 'required|min:6'",
                                  },
                                ],
                                ref: _vm.$t("message.password"),
                                attrs: {
                                  name: _vm.$t("message.password"),
                                  autocomplete: "off",
                                  trim: "",
                                  type: "password",
                                },
                                model: {
                                  value: _vm.adminUser.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.adminUser, "password", $$v)
                                  },
                                  expression: "adminUser.password",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-error" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.first(_vm.$t("message.password"))
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "md-field",
                            {
                              class: {
                                "md-invalid":
                                  _vm.errors.first(
                                    _vm.$t("message.passwordRepeat")
                                  ) != null,
                              },
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.passwordRepeat"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: _vm.editMode
                                      ? "confirmed:" +
                                        _vm.$t("message.password") +
                                        "|min:6"
                                      : "required|confirmed:" +
                                        _vm.$t("message.password") +
                                        "|min:6",
                                    expression:
                                      "\n                                editMode\n                                    ? 'confirmed:' + $t('message.password') + '|min:6'\n                                    : 'required|confirmed:' + $t('message.password') + '|min:6'\n                            ",
                                  },
                                ],
                                attrs: {
                                  name: _vm.$t("message.passwordRepeat"),
                                  autocomplete: "off",
                                  type: "password",
                                },
                                model: {
                                  value: _vm.passwordConfirmation,
                                  callback: function ($$v) {
                                    _vm.passwordConfirmation = $$v
                                  },
                                  expression: "passwordConfirmation",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-error" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.first(
                                      _vm.$t("message.passwordRepeat")
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "md-switch",
                            {
                              staticClass: "md-primary",
                              model: {
                                value: _vm.adminUser.enable,
                                callback: function ($$v) {
                                  _vm.$set(_vm.adminUser, "enable", $$v)
                                },
                                expression: "adminUser.enable",
                              },
                            },
                            [
                              _vm.adminUser.enable
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.active"))),
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.passive"))),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-switch",
                            {
                              staticClass: "md-primary",
                              model: {
                                value: _vm.adminUser.isFullAccess,
                                callback: function ($$v) {
                                  _vm.$set(_vm.adminUser, "isFullAccess", $$v)
                                },
                                expression: "adminUser.isFullAccess",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("adminPanel.fullAccess"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.adminUser.isFullAccess
                        ? _c("b-col", { attrs: { md: "12" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  gap: "15px",
                                  "flex-wrap": "wrap",
                                },
                              },
                              _vm._l(
                                _vm.defaultModel.approvedPages,
                                function (page) {
                                  return _c(
                                    "div",
                                    { key: page.page },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label:
                                              page.displayName || page.page,
                                          },
                                        },
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              attrs: {
                                                checked: [
                                                  "read",
                                                  "write",
                                                ].includes(
                                                  _vm.getPageRole(page.page)
                                                ),
                                                name: "menu",
                                              },
                                              on: {
                                                change: function () {
                                                  return _vm.toggleCheckState(
                                                    page.page,
                                                    "read"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "adminPanel.readPermission"
                                                    )
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              attrs: {
                                                checked: ["write"].includes(
                                                  _vm.getPageRole(page.page)
                                                ),
                                                name: "menu",
                                              },
                                              on: {
                                                change: function () {
                                                  return _vm.toggleCheckState(
                                                    page.page,
                                                    "write"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "adminPanel.writePermission"
                                                    )
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: _vm.loading,
                                type: "submit",
                                variant: "primary",
                              },
                            },
                            [
                              !_vm.loading
                                ? [
                                    !_vm.editMode
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.save"))
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.update"))
                                          ),
                                        ]),
                                  ]
                                : [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "spinner", spin: "" },
                                    }),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            { on: { click: _vm.hideModal } },
                            [
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("message.cancel")) +
                                    "\n                        "
                                ),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }